export default __webpack_public_path__ + "static/media/Img003_fin7.fa6d2dbc.jpg";